export default __webpack_public_path__ + "6b5a8b96e040b77c7999fb3f8ddb00cb.pdf";